// extracted by mini-css-extract-plugin
module.exports = {"disabled":"_2eFvnJUqDh-button-disabled-disabled","dark":"_3pi9h1oZO6-button-disabled-dark","light":"_2egXWgpjxG-button-disabled-light"};